module.exports = __webpack_public_path__ + "img/ufrn.fc6524e8.png";